// extracted by mini-css-extract-plugin
module.exports = {"header":"MainHeader_header__2vgNT"};